import { render } from "./App.vue?vue&type=template&id=510288fd&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=510288fd&scoped=true&lang=css"

import exportComponent from "../../../../20260930-ui-unification/project/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510288fd"]])

export default __exports__